import React, { useEffect, useRef, useState } from 'react';
import { Button, Table, Card, Tabs, Tab } from 'react-bootstrap';
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";
import Circle from "@arcgis/core/geometry/Circle.js";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";
import RouteParameters from "@arcgis/core/rest/support/RouteParameters.js";
import FeatureSet from "@arcgis/core/rest/support/FeatureSet.js";
import * as route from "@arcgis/core/rest/route.js";
import PopupTemplate from "@arcgis/core/PopupTemplate.js";
import Color from "@arcgis/core/Color.js";
import TileLayer from "@arcgis/core/layers/TileLayer.js";
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer.js";
import Basemap from "@arcgis/core/Basemap.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import Search from "@arcgis/core/widgets/Search.js";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol.js";
import Point from "@arcgis/core/geometry/Point.js";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils.js";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import esriConfig from "@arcgis/core/config.js";
import esriRequest from "@arcgis/core/request.js";
import Graphic from "@arcgis/core/Graphic.js";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer.js";
import Draggable from 'react-draggable';
import excel from './images/xls.png';
import * as XLSX from 'xlsx';
import config from './Config.json';

// Global variables
var view;
var selected_stcode;
var selected_subdtcode;
var stid;
var selectedDistrict;
var stname;
var array = [];
var list = [];
var buffergeomGraphic;
var count = 0;
var subdtid;
var subdtname;

// Layer URLs
const STATE_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/61";
const DISTRICT_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/62";
const SUBDISTRICT_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/63";
const VILLAGE_LAYER_URL = "https://webgis2.nic.in/server/rest/services/DBT/DataBankGIS1/MapServer/3";

// Create graphics layers for highlighting and masking
const highlightLayer = new GraphicsLayer({
    id: "highlightLayer",
    opacity: 0.3
});

const maskLayer = new GraphicsLayer({
    id: "maskLayer",
    opacity: 0.7
});

const outlineLayer = new GraphicsLayer({
    id: "outlineLayer"
});

const Nearby = (mapView) => {
    console.log("Nearby component initialized with mapView:", mapView);
    const [data, setData] = useState(config);
    const [optionsdist, setOptionsdist] = useState([]);
    const [optionsvillage, setOptionsvillage] = useState([]);
    const [optionsstdt, setOptionsstdt] = useState([]);
    const [stateselval, setStateselval] = useState("");
    const [districtselval, setDistrictselval] = useState();
    const [subdtselval, setSubdtselval] = useState();
    const [villageselval, setVillageselval] = useState("");
    const [isTableCardOpen, setIsTableCardOpen] = useState(false);
    const [fields, setFields] = useState([]);
    const [resdata, setResdata] = useState([]);
    const [atmfields, setAtmFields] = useState([]);
    const [atmdata, setAtmResdata] = useState([]);
    const [mithrafields, setithraFields] = useState([]);
    const [mithradata, setMithraResdata] = useState([]);
    const [ippbfields, setippbFields] = useState([]);
    const [ippbdata, setippbResdata] = useState([]);
    const [isTablebranchOpen, setIsTablebranchOpen] = useState(false);
    const [isTablemithtaOpen, setIsTablemithraOpen] = useState(false);
    const [isTableAtmOpen, setIsTableAtmhOpen] = useState(false);
    const [isTableippbOpen, setIsTableippbOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [key, setKey] = useState('bank');
    const [tabTitles, setTabTitles] = useState({
        bank: "Bank Branch",
        atm: "ATM",
        mithra: "Bank Mitra",
        ippb: "IPPB",
    });

    const distanceval = useRef(5);
    const villagedata = useRef();

    // Add layers to map when component mounts
    useEffect(() => {
        if (mapView && mapView.view && mapView.view.map) {
            // Add highlight, mask, and outline layers if they don't exist
            if (!mapView.view.map.findLayerById("highlightLayer")) {
                mapView.view.map.add(highlightLayer);
            }
            if (!mapView.view.map.findLayerById("maskLayer")) {
                mapView.view.map.add(maskLayer);
            }
            if (!mapView.view.map.findLayerById("outlineLayer")) {
                mapView.view.map.add(outlineLayer);
            }
        }

        return () => {
            // Clean up layers when component unmounts
            if (mapView && mapView.view && mapView.view.map) {
                const layers = ["highlightLayer", "maskLayer", "outlineLayer"];
                layers.forEach(layerId => {
                    const layer = mapView.view.map.findLayerById(layerId);
                    if (layer) {
                        mapView.view.map.remove(layer);
                    }
                });
            }
        };
    }, [mapView]);

    // Helper function to clear all highlight and mask graphics
    const clearHighlights = () => {
        highlightLayer.removeAll();
        maskLayer.removeAll();
        outlineLayer.removeAll();
    };

    // Helper function to create mask (everything outside the selected area)
    const createMask = (geometry) => {
        if (!geometry || !mapView.view) return;

        try {
            // Get the map's full extent
            const mapExtent = mapView.view.extent.clone();
            
            // Create a large polygon that covers the map extent
            const extentPolygon = {
                type: "polygon",
                rings: [
                    [
                        [mapExtent.xmin, mapExtent.ymin],
                        [mapExtent.xmax, mapExtent.ymin],
                        [mapExtent.xmax, mapExtent.ymax],
                        [mapExtent.xmin, mapExtent.ymax],
                        [mapExtent.xmin, mapExtent.ymin]
                    ]
                ],
                spatialReference: mapExtent.spatialReference
            };

            // Create the mask by subtracting the selected geometry from the extent
            const maskGeometry = geometryEngine.difference(extentPolygon, geometry);
            
            if (maskGeometry) {
                const maskGraphic = new Graphic({
                    geometry: maskGeometry,
                    symbol: new SimpleFillSymbol({
                        color: [0, 0, 0, 0.6], // Semi-transparent black
                        style: "solid",
                        outline: null
                    })
                });
                maskLayer.add(maskGraphic);
            }
        } catch (error) {
            console.error("Error creating mask:", error);
        }
    };

    // Helper function to highlight and outline geometry
    const highlightGeometry = (geometry, outlineColor = [0, 255, 255, 1], fillColor = [0, 255, 255, 0.2]) => {
        if (!geometry) return;

        // Add fill highlight
        const fillGraphic = new Graphic({
            geometry: geometry,
            symbol: new SimpleFillSymbol({
                color: fillColor,
                style: "solid",
                outline: null
            })
        });
        highlightLayer.add(fillGraphic);

        // Add outline
        const outlineGraphic = new Graphic({
            geometry: geometry,
            symbol: new SimpleFillSymbol({
                color: [0, 0, 0, 0],
                style: "solid",
                outline: new SimpleLineSymbol({
                    color: outlineColor,
                    width: 3,
                    style: "solid"
                })
            })
        });
        outlineLayer.add(outlineGraphic);
    };

    if (mapView) {
        var highlightpointSymbol = new SimpleMarkerSymbol(SimpleMarkerSymbol.STYLE_CIRCLE, 12,
            new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, new Color([255, 255, 225]), 3), new Color([255, 255, 255]));

        // Red Circle Symbol
        const redCircle = new SimpleMarkerSymbol({
            color: new Color([255, 0, 0, 0.8]),
            size: 8,
            style: "circle",
            outline: {
                color: new Color([255, 0, 0]),
                width: 1
            }
        });

        // Green Square Symbol
        const greenSquare = new SimpleMarkerSymbol({
            color: new Color([0, 255, 0, 0.8]),
            size: 8,
            style: "square",
            outline: {
                color: new Color([0, 255, 0]),
                width: 1
            }
        });

        // Blue Diamond Symbol
        const blueDiamond = new SimpleMarkerSymbol({
            color: new Color([0, 0, 255, 0.8]),
            size: 8,
            style: "diamond",
            outline: {
                color: new Color([0, 0, 255]),
                width: 1
            }
        });

        const purpleTriangle = new SimpleMarkerSymbol({
            color: new Color([128, 0, 128, 0.8]),
            size: 8,
            style: "triangle",
            outline: {
                color: new Color([128, 0, 128]),
                width: 1
            }
        });

        // Handle State Change
        const NearhandleStateChange = (event) => {
            const selectedState = event.target.value;
            console.log("State selected:", selectedState);
            selected_stcode = event.target.value;

            // Clear previous highlights and masks
            clearHighlights();

            setOptionsdist([]);
            setOptionsstdt([]);
            setOptionsvillage([]);
            setVillageselval("");

            setIsLoading(true);

            if (selectedState === "") {
                stid = event.target.value;
                stname = event.target.options[event.target.selectedIndex]?.text || "";
                setStateselval(selectedState);
                setIsLoading(false);
            } else {
                stid = event.target.value;
                stname = event.target.options[event.target.selectedIndex]?.text || "";
                setStateselval(selectedState);

                // Query state geometry using state_lgd field
                const params = new Query({
                    returnGeometry: true,
                    where: "state_lgd = " + stid,
                    outSpatialReference: 3857,
                    outFields: ["*"]
                });

                console.log("Querying state with URL:", STATE_LAYER_URL + "?token=");
                console.log("State query params:", params);

                query.executeQueryJSON(STATE_LAYER_URL + "?token=", params)
                    .then(function (response) {
                        console.log("State response:", response);
                        if (response.features && response.features.length > 0) {
                            const stateGeometry = response.features[0].geometry;
                            
                            // Highlight state and create mask
                            highlightGeometry(stateGeometry, [0, 255, 255, 1], [0, 255, 255, 0.2]);
                            createMask(stateGeometry);
                            
                            const curGeomExtent = stateGeometry.extent;
                            mapView.view.goTo({
                                target: curGeomExtent
                            }).then(() => {
                                mapView.view.zoom = 8;
                            });
                            mapView.view.extent = curGeomExtent;

                            // Query districts using state_lgd field
                            const dtparams = new Query({
                                returnGeometry: false,
                                outFields: ["dist_lgd", "dtname"],
                                where: "state_lgd = " + stid,
                                orderByFields: ["dtname"],
                                outSpatialReference: 3857
                            });

                            console.log("Querying districts with URL:", DISTRICT_LAYER_URL + "?token=");
                            console.log("District query params:", dtparams);

                            return query.executeQueryJSON(DISTRICT_LAYER_URL + "?token=", dtparams);
                        } else {
                            console.warn("No state features found for state:", stid);
                            return { features: [] };
                        }
                    })
                    .then(getDistrictResults)
                    .catch((error) => {
                        console.error("Error in NearhandleStateChange:", error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        };

        function getDistrictResults(response) {
            console.log("getDistrictResults called with:", response);
            if (response && response.features && response.features.length > 0) {
                var distFeatures = response.features;
                console.log("District features:", distFeatures);

                var optionsArray = [];
                for (var i = 0; i < distFeatures.length; i++) {
                    console.log("District feature", i, "attributes:", distFeatures[i].attributes);
                    optionsArray.push({
                        value: distFeatures[i].attributes["dist_lgd"],
                        label: distFeatures[i].attributes["dtname"],
                    });
                }
                console.log("District options array:", optionsArray);
                setOptionsdist(optionsArray);
            } else {
                console.warn("No district features found in response");
                setOptionsdist([]);
            }
        }

        // Handle District Change
        // Handle District Change
const NearhandleDistrictChange = (event) => {
    console.log("District selected:", event.target.value);
    
    // Clear previous highlights and masks
    clearHighlights();
    
    setVillageselval("");
    setOptionsstdt([]);
    setOptionsvillage([]);
    const selectedDistrict = event.target.value;

    setIsLoading(true);

    if (selectedDistrict === "") {
        setDistrictselval(selectedDistrict);
        setIsLoading(false);
    } else {
        setDistrictselval(selectedDistrict);

        // Query district geometry using dist_lgd field
        const dtparam = new Query({
            returnGeometry: true,
            where: "dist_lgd = " + selectedDistrict,
            outFields: ["*"],
            outSpatialReference: 3857
        });

        console.log("Querying district geometry with URL:", DISTRICT_LAYER_URL + "?token=");
        console.log("District geometry params:", dtparam);

        query.executeQueryJSON(DISTRICT_LAYER_URL + "?token=", dtparam)
            .then(function(response) {
                console.log("District geometry response:", response);
                if (response.features && response.features.length > 0) {
                    const districtGeometry = response.features[0].geometry;
                    
                    // Highlight district and create mask
                    highlightGeometry(districtGeometry, [255, 255, 0, 1], [255, 255, 0, 0.2]);
                    createMask(districtGeometry);
                    
                    const curGeomExtent = districtGeometry.extent;
                    mapView.view.goTo({
                        target: curGeomExtent
                    }).then(() => {
                        mapView.view.zoom = 9;
                    });
                    mapView.view.extent = curGeomExtent;

                    // Query sub-districts from SUBDISTRICT layer (ID: 63) first
                    const subdtParams = new Query({
                        where: "dist_lgd = " + selectedDistrict,
                        outFields: ["sdtname", "sdtcode11", "subdt_lgd", "dtname", "dist_lgd"],
                        returnGeometry: false,
                        outSpatialReference: 3857
                    });

                    console.log("Querying subdistricts from SUBDISTRICT layer with dist_lgd =", selectedDistrict);
                    
                    return query.executeQueryJSON(SUBDISTRICT_LAYER_URL + "?token=", subdtParams);
                } else {
                    console.warn("No district geometry found");
                    return { features: [] };
                }
            })
            .then(function(subdtResponse) {
                console.log("Subdistrict query response:", subdtResponse);
                
                if (subdtResponse && subdtResponse.features && subdtResponse.features.length > 0) {
                    var subdtFeatures = subdtResponse.features;
                    console.log("Subdistrict features found:", subdtFeatures.length);
                    
                    // Log all features for debugging
                    for (var i = 0; i < subdtFeatures.length; i++) {
                        console.log(`Subdistrict ${i}:`, subdtFeatures[i].attributes);
                    }
                    
                    var optionsArray = [];
                    
                    for (var i = 0; i < subdtFeatures.length; i++) {
                        var attrs = subdtFeatures[i].attributes;
                        
                        // Get subdistrict name from various possible fields
                        var sdtname = attrs["sdtname"] || attrs["stdtname"] || attrs["subdtname"] || null;
                        var sdtcode = null;
                        
                        // Priority order for code: subdt_lgd (most reliable) > sdtcode11 > others
                        if (attrs["subdt_lgd"] && attrs["subdt_lgd"] !== null && attrs["subdt_lgd"] !== 0) {
                            sdtcode = attrs["subdt_lgd"];
                            console.log(`Using subdt_lgd for ${sdtname}: ${sdtcode}`);
                        } else if (attrs["sdtcode11"] && attrs["sdtcode11"] !== null) {
                            sdtcode = attrs["sdtcode11"];
                            console.log(`Using sdtcode11 for ${sdtname}: ${sdtcode}`);
                        }
                        
                        // Special handling for Kuchaman City
                        if (sdtname && (sdtname.toLowerCase().includes("kuchaman") || sdtname.toLowerCase().includes("kuchaman city"))) {
                            console.log("🎯 Found KUCHAMAN CITY:", sdtname);
                            // Ensure it has a valid code
                            if (!sdtcode && attrs["subdt_lgd"]) {
                                sdtcode = attrs["subdt_lgd"];
                            }
                            if (!sdtcode && attrs["sdtcode11"]) {
                                sdtcode = attrs["sdtcode11"];
                            }
                            if (!sdtcode) {
                                console.warn("KUCHAMAN CITY found but has no code!");
                                console.log("Available attributes:", attrs);
                            }
                        }
                        
                        if (sdtname && sdtcode) {
                            console.log(`✅ Adding subdistrict: ${sdtname} with code: ${sdtcode}`);
                            optionsArray.push({
                                value: String(sdtcode),
                                label: sdtname,
                            });
                        } else if (sdtname) {
                            console.warn(`⚠️ Subdistrict "${sdtname}" has no valid code. Attributes:`, attrs);
                        }
                    }
                    
                    // If no subdistricts found in SUBDISTRICT layer, try VILLAGE layer as fallback
                    if (optionsArray.length === 0) {
                        console.log("No subdistricts found in SUBDISTRICT layer, trying VILLAGE layer as fallback...");
                        
                        const villageLayerParams = new Query({
                            where: "dist_lgd = " + selectedDistrict,
                            outFields: ["stdtname", "sdt_2011", "dist_lgd"],
                            returnDistinctValues: true,
                            returnGeometry: false,
                            outSpatialReference: 3857
                        });
                        
                        return query.executeQueryJSON(VILLAGE_LAYER_URL + "?token=", villageLayerParams);
                    }
                    
                    return { features: optionsArray };
                } else {
                    console.warn("No subdistrict features found in SUBDISTRICT layer, trying VILLAGE layer...");
                    
                    // Fallback to VILLAGE layer
                    const villageLayerParams = new Query({
                        where: "dist_lgd = " + selectedDistrict,
                        outFields: ["stdtname", "sdt_2011", "dist_lgd"],
                        returnDistinctValues: true,
                        returnGeometry: false,
                        outSpatialReference: 3857
                    });
                    
                    return query.executeQueryJSON(VILLAGE_LAYER_URL + "?token=", villageLayerParams);
                }
            })
            .then(function(finalResponse) {
                console.log("Final subdistrict response:", finalResponse);
                
                // Check if this is from the fallback village layer query
                if (finalResponse.features && finalResponse.features.length > 0 && finalResponse.features[0].attributes && finalResponse.features[0].attributes.stdtname) {
                    console.log("Processing fallback village layer results");
                    
                    var optionsArray = [];
                    var villageFeatures = finalResponse.features;
                    
                    for (var i = 0; i < villageFeatures.length; i++) {
                        var attrs = villageFeatures[i].attributes;
                        var sdtname = attrs["stdtname"];
                        var sdtcode = attrs["sdt_2011"];
                        
                        if (sdtname && sdtcode) {
                            // Pad code to ensure it's 5 digits
                            sdtcode = String(sdtcode).padStart(5, '0');
                            
                            console.log(`Adding subdistrict from village layer: ${sdtname} (${sdtcode})`);
                            optionsArray.push({
                                value: sdtcode,
                                label: sdtname,
                            });
                        }
                    }
                    
                    // Remove duplicates
                    const uniqueOptions = optionsArray.filter((option, index, self) =>
                        index === self.findIndex((o) => o.value === option.value)
                    );
                    
                    console.log("Final unique subdistrict options from village layer:", uniqueOptions);
                    setOptionsstdt(uniqueOptions);
                } 
                // Check if this is our manually created options array
                else if (finalResponse.features && Array.isArray(finalResponse.features)) {
                    console.log("Setting subdistrict options from SUBDISTRICT layer");
                    setOptionsstdt(finalResponse.features);
                }
                else {
                    console.warn("No subdistricts found in any layer");
                    setOptionsstdt([]);
                }
            })
            .catch((error) => {
                console.error("Error in NearhandleDistrictChange:", error);
                setOptionsstdt([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
};

       function getsubdistResults(response) {
    console.log("getsubdistResults called with:", response);
    
    if (response && response.features && response.features.length > 0) {
        var subdtFeatures = response.features;
        console.log("Subdistrict features count:", subdtFeatures.length);
        
        // Log ALL features to debug
        for (var i = 0; i < subdtFeatures.length; i++) {
            console.log(`Feature ${i} attributes:`, subdtFeatures[i].attributes);
        }

        var optionsArray = [];
        
        for (var i = 0; i < subdtFeatures.length; i++) {
            var attrs = subdtFeatures[i].attributes;
            
            // Try ALL possible field names for subdistrict name
            var sdtname = attrs["sdtname"] || 
                         attrs["stdtname"] || 
                         attrs["subdtname"] || 
                         attrs["SUBDTNAME"] || 
                         attrs["sdt_name"] || 
                         attrs["dtname"] || // Sometimes subdistrict name might be in dtname
                         null;
            
            // Try ALL possible field names for subdistrict code
            var sdtcode = attrs["sdtcode11"] || 
                         attrs["sdt_2011"] || 
                         attrs["subdtcode"] || 
                         attrs["SUBDTCODE"] || 
                         attrs["subdt_lgd"] || // This is likely the correct one
                         attrs["Dist_LGD"] ||
                         null;
            
            // Special handling for Kuchaman City
            if (sdtname && (sdtname.toLowerCase().includes("kuchaman") || sdtname.toLowerCase().includes("kuchaman city"))) {
                console.log("🎯 Found KUCHAMAN CITY:", sdtname, "with code:", sdtcode);
                // Ensure we have a valid code
                if (!sdtcode && attrs["subdt_lgd"]) {
                    sdtcode = attrs["subdt_lgd"];
                }
                if (!sdtcode && attrs["sdtcode11"]) {
                    sdtcode = attrs["sdtcode11"];
                }
            }
            
            if (sdtname && sdtcode) {
                console.log(`✅ Adding subdistrict: ${sdtname} (${sdtcode})`);
                optionsArray.push({
                    value: String(sdtcode), // Ensure it's a string
                    label: sdtname,
                });
            } else {
                console.warn(`❌ Skipping subdistrict - Name: ${sdtname}, Code: ${sdtcode}`);
                console.log("Full attributes for skipped item:", attrs);
            }
        }

        // Remove duplicates
        const uniqueOptions = optionsArray.filter((option, index, self) =>
            index === self.findIndex((o) => o.value === option.value)
        );

        console.log("Final subdistrict options:", uniqueOptions);
        
        // Specifically check if Kuchaman City is in the options
        const kuchamanOption = uniqueOptions.find(opt => 
            opt.label.toLowerCase().includes("kuchaman")
        );
        
        if (kuchamanOption) {
            console.log("✅ Kuchaman City found in options:", kuchamanOption);
        } else {
            console.log("❌ Kuchaman City NOT found in processed options");
            console.log("Available options:", uniqueOptions.map(opt => opt.label));
        }
        
        setOptionsstdt(uniqueOptions);
    } else {
        console.warn("No subdistrict features found in response");
        setOptionsstdt([]);
    }
}

// Handle Subdistrict Change - WORKING VERSION
const NearhandlesubDistrictChange = (event) => {
    console.log("=== Subdistrict Change Started ===");
    console.log("Selected text:", event.target.options[event.target.selectedIndex]?.text);
    
    clearHighlights();
    setOptionsvillage([]);
    setVillageselval("");
    
    const selectedsubdtText = event.target.options[event.target.selectedIndex]?.text || "";
    
    setIsLoading(true);

    if (selectedsubdtText === "") {
        setSubdtselval(selectedsubdtText);
        setIsLoading(false);
        return;
    }
    
    setSubdtselval(event.target.value);
    subdtname = selectedsubdtText;
    
    console.log("Searching villages for subdistrict:", subdtname);
    
    // For KUCHAMAN CITY: Use stdtname query (works based on your URL)
    // For SUIGAM: Use sdt_2011 = '6166'
    
    let villageWhereClause = "";
    
    // Check which subdistrict we're dealing with
    if (subdtname.toUpperCase() === "SUIGAM") {
        villageWhereClause = "sdt_2011 = '6166'";
        console.log("Using sdt_2011 query for SUIGAM:", villageWhereClause);
    } else {
        // For KUCHAMAN CITY and others, use stdtname
        villageWhereClause = "stdtname = '" + subdtname.replace(/'/g, "''") + "'";
        console.log("Using stdtname query:", villageWhereClause);
    }
    
    // Direct fetch approach (more reliable than ArcGIS Query object)
    const villageUrl = VILLAGE_LAYER_URL + "/query?where=" + encodeURIComponent(villageWhereClause) + 
                      "&outFields=vil_2011,vil_name11,stdtname&returnGeometry=false&orderByFields=vil_name11&f=json";
    
    console.log("Fetching villages from URL:", villageUrl);
    
    fetch(villageUrl + "&token=")
        .then(response => response.json())
        .then(data => {
            console.log("Village API response:", data);
            
            if (data.error) {
                console.error("API Error:", data.error);
                throw new Error(data.error.message);
            }
            
            if (data.features && data.features.length > 0) {
                var optionsArray = [];
                
                for (var i = 0; i < data.features.length; i++) {
                    var attrs = data.features[i].attributes;
                    var vilname = attrs["vil_name11"];
                    var vilcode = attrs["vil_2011"];
                    
                    if (vilname && vilcode) {
                        optionsArray.push({
                            value: String(vilcode),
                            label: vilname,
                        });
                        console.log(`Village ${i+1}: ${vilname} (${vilcode})`);
                    }
                }
                
                console.log(`✅ Total villages loaded: ${optionsArray.length}`);
                setOptionsvillage(optionsArray);
                
                // Now get subdistrict geometry for highlighting
                let geomWhereClause = "";
                if (subdtname.toUpperCase() === "SUIGAM") {
                    geomWhereClause = "sdtname = 'SUIGAM'";
                } else {
                    geomWhereClause = "sdtname = '" + subdtname.replace(/'/g, "''") + "'";
                }
                
                const geomUrl = SUBDISTRICT_LAYER_URL + "/query?where=" + encodeURIComponent(geomWhereClause) + 
                               "&outFields=*&returnGeometry=true&f=json";
                
                fetch(geomUrl + "&token=")
                    .then(res => res.json())
                    .then(geomData => {
                        if (geomData.features && geomData.features.length > 0) {
                            const geometry = geomData.features[0].geometry;
                            if (geometry) {
                                // Convert to ArcGIS Graphic
                                const graphic = new Graphic({
                                    geometry: geometry,
                                    symbol: new SimpleFillSymbol({
                                        color: [255, 0, 255, 0.2],
                                        outline: new SimpleLineSymbol({
                                            color: [255, 0, 255],
                                            width: 3
                                        })
                                    })
                                });
                                highlightLayer.removeAll();
                                highlightLayer.add(graphic);
                                
                                // Zoom to extent
                                if (geometry.extent) {
                                    mapView.view.goTo({
                                        target: geometry.extent,
                                        zoom: 10
                                    });
                                }
                            }
                        }
                    })
                    .catch(err => console.error("Error getting geometry:", err));
                    
            } else {
                console.warn(`No villages found for subdistrict: ${subdtname}`);
                setOptionsvillage([]);
                alert(`No villages found for "${subdtname}".`);
            }
        })
        .catch((error) => {
            console.error("Error in village query:", error);
            setOptionsvillage([]);
            alert("Error loading villages: " + error.message);
        })
        .finally(() => {
            setIsLoading(false);
        });
};

        function getVillageResults(response) {
            console.log("getVillageResults called with:", response);
            
            if (response && response.features && response.features.length > 0) {
                var VillageFeatures = response.features;
                console.log("Village features found:", VillageFeatures.length);

                if (VillageFeatures.length > 0) {
                    console.log("Sample village attributes:", VillageFeatures[0].attributes);
                }

                var optionsArray = [];
                
                for (var i = 0; i < VillageFeatures.length; i++) {
                    var attrs = VillageFeatures[i].attributes;
                    
                    var vilname = attrs["vil_name11"];
                    var vilcode = attrs["vil_2011"];
                    
                    if (vilname && vilcode) {
                        console.log(`Found village: ${vilname} (${vilcode})`);
                        optionsArray.push({
                            value: vilcode,
                            label: vilname,
                        });
                    }
                }

                const uniqueOptions = optionsArray.filter((option, index, self) =>
                    index === self.findIndex((o) => o.value === option.value)
                );

                console.log("Village options array:", uniqueOptions);
                setOptionsvillage(uniqueOptions);
            } else {
                console.warn("No village features found in response");
                setOptionsvillage([]);
            }
        }

        // Handle Village Change
        const NearhandleVillageChange = (event) => {
            console.log("Village selected:", event.target.value);
            
            // Clear previous highlights and masks
            clearHighlights();
            
            setIsLoading(true);

            const selectedVillage = event.target.value;
            additionalGraphics = [];

            if (selectedVillage === "") {
                setVillageselval(selectedVillage);
                setIsLoading(false);
            } else {
                setVillageselval(selectedVillage);

                const params = new Query({
                    returnGeometry: true,
                    where: "vil_2011 = '" + selectedVillage + "'",
                    outFields: ["*"],
                    outSpatialReference: 3857
                });

                console.log("Village geometry query:", params);

                query.executeQueryJSON(VILLAGE_LAYER_URL + "?token=", params)
                    .then(villageredata)
                    .catch((error) => {
                        console.error("Error in NearhandleVillageChange:", error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        };

        function villageredata(response) {
            console.log("Selected village data:", response);
            if (response && response.features && response.features.length > 0) {
                const villageGeometry = response.features[0].geometry;
                
                // Highlight village and create mask
                highlightGeometry(villageGeometry, [0, 255, 0, 1], [0, 255, 0, 0.2]);
                createMask(villageGeometry);
                
                console.log("Village geometry:", villageGeometry);
                console.log("Village attributes:", response.features[0].attributes);
                
                distanceval.current = 5;
                villagedata.current = response;
                mapView.view.map.findLayerById("routeGL_MB")?.graphics.removeAll();
            } else {
                console.warn("No village geometry found");
            }
        }

        const handleBlur = (evt) => {
            const distance = document.getElementById('txtDistance').value;
            console.log("Distance entered:", distance);
            
            if (distance === "" || distance === " " || distance == 0) {
                alert("Please Enter Distance");
                return false;
            }
            
            if (villagedata.current) {
                console.log("Creating buffer with village data:", villagedata.current);
                Createbuffer(villagedata.current);
            } else {
                alert("Please select a village first");
            }
        };

        function Createbuffer(response) {
            console.log("Createbuffer called with:", response);
            setKey('bank');

            mapView.view.map.findLayerById("Zoompoint")?.graphics.removeAll();
            mapView.view.map.findLayerById("Bankpoint")?.graphics.removeAll();

            setAtmResdata([]);
            setResdata([]);
            setMithraResdata([]);
            setippbResdata([]);
            setIsTablebranchOpen(false);
            setIsTableAtmhOpen(false);
            setIsTablemithraOpen(false);
            setIsTableippbOpen(false);

            if (!response || !response.features || response.features.length === 0) {
                console.error("Invalid response for buffer creation");
                return;
            }

            var curGeomExtent = response.features[0].geometry;
            mapView.view.graphics.removeAll();

            var circleSymb = new SimpleFillSymbol(
                SimpleFillSymbol.STYLE_SOLID,
                new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
                    new Color([0, 150, 255]), 4), new Color([229, 255, 255, 0.9])
            );

            const yellowircle = new SimpleMarkerSymbol({
                color: new Color([139, 0, 139, 0.8]),
                size: 12,
                style: "circle",
                outline: {
                    color: new Color([139, 0, 139]),
                    width: 1
                }
            });

            var centergrapgics = new Graphic({
                geometry: response.features[0].geometry,
                symbol: yellowircle
            });
            mapView.view.graphics.add(centergrapgics);

            const circleSymbol = new SimpleFillSymbol({
                color: [0, 0, 255, 0.20],
                outline: {
                    color: [0, 150, 255],
                    width: 2
                }
            });

            var circleGeometry = new Circle({
                center: response.features[0].geometry,
                geodesic: true,
                numberOfPoints: 100,
                radius: document.getElementById('txtDistance').value,
                radiusUnit: "kilometers"
            });

            var buffergeomGraphic = new Graphic({
                geometry: circleGeometry,
                symbol: circleSymbol
            });
            mapView.view.graphics.add(buffergeomGraphic);

            mapView.view.goTo({
                target: response.features[0].geometry,
                zoom: 11
            });

            var dtparams = new Query({
                outFields: ["*"],
                where: "1=1",
                geometry: circleGeometry,
            });

            query.executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + 5 + "?token=", dtparams)
                .then(response => Results(response, "Bank"))
                .catch(err => console.error("Bank query error:", err));

            query.executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + 6 + "?token=", dtparams)
                .then(response => Results(response, "ATM"))
                .catch(err => console.error("ATM query error:", err));

            query.executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + 7 + "?token=", dtparams)
                .then(response => Results(response, "Mithra"))
                .catch(err => console.error("Mithra query error:", err));

            query.executeQueryJSON(data.layerForQuery.DataLayer[0].Url + "/" + 66 + "?token=", dtparams)
                .then(response => Results(response, "IPPB"))
                .catch(err => console.error("IPPB query error:", err));
        }

        var additionalGraphics = [];

        function Results(response, param) {
            console.log(`Results for ${param}:`, response);
            list = [];
            array = [];
            setIsTableCardOpen(true);

            if (!response || !response.features) {
                console.warn(`No features in response for ${param}`);
                return;
            }

            let larArray = response.features;
            for (var m = 0; m < larArray.length; m++) {
                array.push(larArray[m]);
                if (param === "Bank") {
                    additionalGraphics.push(new Graphic({
                        geometry: { type: "point", longitude: larArray[m].attributes.longitude, latitude: larArray[m].attributes.latitude },
                        symbol: redCircle
                    }));
                } else if (param === "ATM") {
                    additionalGraphics.push(new Graphic({
                        geometry: { type: "point", longitude: larArray[m].attributes.longitude, latitude: larArray[m].attributes.latitude },
                        symbol: blueDiamond
                    }));
                } else if (param == "Mithra") {
                    additionalGraphics.push(new Graphic({
                        geometry: { type: "point", longitude: larArray[m].attributes.longitude, latitude: larArray[m].attributes.latitude },
                        symbol: greenSquare
                    }));
                } else if (param == "IPPB") {
                    additionalGraphics.push(new Graphic({
                        geometry: { type: "point", longitude: larArray[m].attributes.longitude, latitude: larArray[m].attributes.latitude },
                        symbol: purpleTriangle
                    }));
                }
            }

            array.forEach(function (item) {
                list.push(item.attributes);
            });

            console.log(`${param} data list:`, list);
            
            if (param === "Bank") {
                if (list.length > 0) {
                    setFields(data.layerForQuery.DataLayer[0].infotemplates[0].fields);
                    setResdata(list);
                    setIsTablebranchOpen(true);
                }
            } else if (param === "ATM") {
                if (list.length > 0) {
                    setAtmFields(data.layerForQuery.DataLayer[0].infotemplates[1].fields);
                    setAtmResdata(list);
                    setIsTableAtmhOpen(true);
                }
            } else if (param == "Mithra") {
                if (list.length > 0) {
                    setithraFields(data.layerForQuery.DataLayer[0].infotemplates[2].fields);
                    setMithraResdata(list);
                    setIsTablemithraOpen(true);
                    GraphicsFun();
                }
            } else if (param == "IPPB") {
                if (list.length > 0) {
                    setippbFields(data.layerForQuery.DataLayer[0].infotemplates[9].fields);
                    setippbResdata(list);
                    setIsTableippbOpen(true);
                    GraphicsFun();
                }
            }
        }

        function GraphicsFun() {
            if (additionalGraphics.length > 0) {
                mapView.view.map.findLayerById("Bankpoint")?.addMany(additionalGraphics);
                console.log("Added", additionalGraphics.length, "graphics to Bankpoint layer");
            }
        }

        const RowHandler = (latitude, longitude) => {
            console.log("Row clicked:", latitude, longitude);
            mapView.view.map.findLayerById("Zoompoint")?.graphics.removeAll();

            const point = new Point({
                longitude: longitude,
                latitude: latitude
            });

            mapView.view.goTo({
                target: point,
                zoom: 15
            });

            var zoomsymbol = new SimpleMarkerSymbol({
                outline: {
                    color: [255, 0, 0],
                    width: 5
                }
            });

            if (villagedata.current && villagedata.current.features && villagedata.current.features.length > 0) {
                const start = new Graphic({
                    geometry: { type: "point", longitude: villagedata.current.features[0].geometry.longitude, latitude: villagedata.current.features[0].geometry.latitude }
                });

                const stop = new Graphic({
                    geometry: { type: "point", longitude: longitude, latitude: latitude }
                });

                const routeParams2 = new RouteParameters({
                    stops: new FeatureSet({ features: [start, stop] }),
                    outSpatialReference: { wkid: 3857 },
                    returnDirections: true
                });

                route.solve(data.layerForQuery.Route.Url, routeParams2)
                    .then(function (values) {
                        console.log("Route solved:", values);
                        mapView.view.map.findLayerById("routeGL_MB")?.graphics.removeAll();

                        if (values.routeResults && values.routeResults.length > 0) {
                            let directionpath = new Graphic({
                                geometry: values.routeResults[0].route.geometry,
                                symbol: {
                                    type: "simple-line",
                                    color: [0, 0, 255, 0.7],
                                    width: 4
                                }
                            });
                            mapView.view.map.findLayerById("routeGL_MB")?.add(directionpath);
                        }
                    })
                    .catch(err => console.error("Route solving error:", err));
            }

            mapView.view.map.findLayerById("Zoompoint")?.add(new Graphic({
                geometry: point,
                symbol: zoomsymbol
            }));
        };

        const handleCloseTableCard = () => {
            setIsTableCardOpen(false);
            setIsTablebranchOpen(false);
            setIsTableAtmhOpen(false);
            setIsTablemithraOpen(false);
            setIsTableippbOpen(false);
            mapView.view.map.findLayerById("Bankpoint")?.graphics.removeAll();
            mapView.view.map.findLayerById("Zoompoint")?.graphics.removeAll();
            mapView.view.map.findLayerById("routeGL_MB")?.graphics.removeAll();
            clearHighlights();
        };

        const tabselect = (evt) => {
            if (evt !== key) {
                setKey(evt);
            }
        };

        const handleExportToExcel = () => {
            let exportData = [];
            let fields = [];
            let fileName = '';

            switch (key) {
                case 'bank':
                    if (resdata.length === 0) {
                        alert('No data available to export for Bank Branch');
                        return;
                    }
                    exportData = resdata;
                    fields = data.layerForQuery.DataLayer[0].infotemplates[0].fields;
                    fileName = 'Bank_Branch_Data';
                    break;

                case 'atm':
                    if (atmdata.length === 0) {
                        alert('No data available to export for ATM');
                        return;
                    }
                    exportData = atmdata;
                    fields = data.layerForQuery.DataLayer[0].infotemplates[1].fields;
                    fileName = 'ATM_Data';
                    break;

                case 'mithra':
                    if (mithradata.length === 0) {
                        alert('No data available to export for Bank Mitra');
                        return;
                    }
                    exportData = mithradata;
                    fields = data.layerForQuery.DataLayer[0].infotemplates[2].fields;
                    fileName = 'Bank_Mitra_Data';
                    break;

                case 'ippb':
                    if (ippbdata.length === 0) {
                        alert('No data available to export for IPPB');
                        return;
                    }
                    exportData = ippbdata;
                    fields = data.layerForQuery.DataLayer[0].infotemplates[9].fields;
                    fileName = 'IPPB_Data';
                    break;

                default:
                    alert('No active tab selected');
                    return;
            }

            const headers = fields.map(field => field.alias).join(',');
            const csvRows = exportData.map(row => {
                return fields.map(field => {
                    const value = row[field.name] || '-';
                    return `"${String(value).replace(/"/g, '""')}"`;
                }).join(',');
            });

            const csvContent = [headers, ...csvRows].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);

            link.setAttribute('href', url);
            link.setAttribute('download', `${fileName}_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(url), 100);
        };

        return (
            <div>
                {isLoading && (
                    <div className='mob_spiner'
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "-webkit-fill-available",
                            height: "-webkit-fill-available",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            backdropFilter: "blur(5px)",
                            zIndex: 9999,
                        }}
                    >
                        <div
                            style={{
                                width: "50px",
                                height: "50px",
                                border: "4px solid #fff",
                                borderTop: "4px solid transparent",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                            }}
                        ></div>

                        <style>
                            {`
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}
                        </style>
                    </div>
                )}

                <div>
                    <label>State</label>
                    <select
                        className="form-select"
                        value={stateselval}
                        onChange={NearhandleStateChange}
                        style={{ width: "100%", marginBottom: "10px" }}
                    >
                        <option value="">Select State</option>
                        {mapView.states && mapView.states.map((stateOption) => (
                            <option key={stateOption.value} value={stateOption.value}>{stateOption.label}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label>District</label>
                    <select
                        className="form-select"
                        value={districtselval}
                        onChange={NearhandleDistrictChange}
                        style={{ width: "100%" }}
                    >
                        <option value="">Select District</option>
                        {optionsdist.map((districtOption) => (
                            <option key={districtOption.value} value={districtOption.value}>{districtOption.label}</option>
                        ))}
                    </select>

                    <label>Sub District</label>
                    <select
    className="form-select"
    value={subdtselval}
    onChange={NearhandlesubDistrictChange}
    style={{ width: "100%" }}
>
    <option value="">Select Sub District</option>
    {optionsstdt.map((subOption) => (
        <option key={subOption.value} value={subOption.value}>
            {subOption.label}
        </option>
    ))}
</select>

                    <label>Village</label>
                    <select
                        className="form-select"
                        value={villageselval}
                        onChange={NearhandleVillageChange}
                        style={{ width: "100%" }}
                    >
                        <option value="">Select Village</option>
                        {optionsvillage.map((VillageOption) => (
                            <option key={VillageOption.value} value={VillageOption.value}>{VillageOption.label}</option>
                        ))}
                    </select>

                    <br></br>
                </div>

                {villageselval && (
                    <div>
                        <label>Enter Distance (KM)</label>
                        <input placeholder="Enter Distance" type="number" className="form-select" title="Buffer Distance" id="txtDistance" min="1" maxLength="5" style={{ width: "100%" }} />
                        <br></br>
                        <input id="btnBufferQuery" type="button" value="Execute" className="btn btn-primary me-2 shadow" onClick={handleBlur} />
                    </div>
                )}

                {/* Table Card */}
                {isTableCardOpen && (
                    <Draggable
                        disabled={window.innerWidth <= 768}
                        handle=".drag-handle"
                    >
                        <div
                            style={{
                                position: 'fixed',
                                bottom: '5px',
                                left: '5%',
                                transform: 'translateX(-50%)',
                                zIndex: 1060,
                                width: "30%",
                                zoom: "0.8"
                            }}
                            className='mob_bot_card'
                        >
                            <Card
                                className={`card-container card_drag_mob ${isMinimized ? 'card-minimized' : 'card-maximized'}`}
                                style={{ borderRadius: '10px' }}
                            >
                                <Card.Header
                                    className="d-flex justify-content-between drag-handle"
                                    style={{ backgroundColor: "#dcf5f2", height: "45px" }}
                                >
                                    <h5 style={{ fontSize: "large", fontWeight: "700" }}>Result Table</h5>
                                    <div className="d-flex">
                                        <Button variant="link" onClick={() => setIsMinimized(!isMinimized)}>
                                            <i className="material-icons" style={{ fontSize: '24px' }}>
                                                {isMinimized ? 'fullscreen' : 'minimize'}
                                            </i>
                                        </Button>
                                        <Button variant="link" onClick={handleCloseTableCard}>
                                            <i className="material-icons" style={{ fontSize: '24px' }}>close</i>
                                        </Button>
                                    </div>
                                </Card.Header>

                                {!isMinimized && (
                                    <Card.Body>
                                        <img
                                            src={excel}
                                            alt="Export to Excel"
                                            onClick={() => handleExportToExcel()}
                                            style={{
                                                cursor: 'pointer',
                                                width: '32px',
                                                height: '32px',
                                                marginLeft: '10px',
                                                transition: 'transform 0.2s',
                                                justifySelf: "self-end",
                                                float: "inline-end"
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                            title="Export to Excel"
                                        />
                                        <Tabs
                                            id="controlled-tab-example"
                                            activeKey={key}
                                            onSelect={tabselect}
                                            className="mb-3"
                                        >
                                            {/* Bank Tab */}
                                            <Tab
                                                eventKey="bank"
                                                title={
                                                    <div className="d-flex align-items-center">
                                                        <span>{tabTitles.bank}</span>
                                                        {isTablebranchOpen && (
                                                            <span style={{ marginLeft: "5px" }}>
                                                                ({resdata.length})
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            >
                                                {isTablebranchOpen ? (
                                                    resdata.length > 0 ? (
                                                        <div className="table-responsive" style={{ maxHeight: "13rem", overflowY: "auto" }}>
                                                            <Table className="table table-bordered table-striped table-hover tableborderedth tablefontsize dashtbl">
                                                                <thead className="table-header" style={{ position: "sticky", top: "-1px", zIndex: 2, backgroundColor: "#fff" }}>
                                                                    <tr>
                                                                        {fields.map((field) => (
                                                                            <th key={field.name}>{field.alias}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {resdata.map((row, index) => (
                                                                        <tr
                                                                            key={`${row.latitude}-${row.longitude}-${index}`}
                                                                            onClick={() => RowHandler(row.latitude, row.longitude)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {fields.map((field) => (
                                                                                <td key={field.name}>{row[field.name] || "-"}</td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <div className="p-4 border rounded-xl shadow-md">
                                                            <p>No Features Found</p>
                                                        </div>
                                                    )
                                                ) : null}
                                            </Tab>

                                            {/* ATM Tab */}
                                            <Tab
                                                eventKey="atm"
                                                title={
                                                    <div className="d-flex align-items-center">
                                                        <span>{tabTitles.atm}</span>
                                                        {isTableAtmOpen && (
                                                            <span style={{ marginLeft: "5px" }}>
                                                                ({atmdata.length})
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            >
                                                {isTableAtmOpen ? (
                                                    atmdata.length > 0 ? (
                                                        <div className="table-responsive" style={{ maxHeight: "13rem", overflowY: "auto" }}>
                                                            <Table className="table table-bordered table-striped table-hover tableborderedth tablefontsize dashtbl">
                                                                <thead className="table-header" style={{ position: 'sticky', top: '-1px', zIndex: 2, backgroundColor: "#fff" }}>
                                                                    <tr>
                                                                        {atmfields.map((field) => (
                                                                            <th key={field.name}>{field.alias}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {atmdata.map((row, index) => (
                                                                        <tr
                                                                            key={`${row.latitude}-${row.longitude}-${index}`}
                                                                            onClick={() => RowHandler(row.latitude, row.longitude)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {atmfields.map((field) => (
                                                                                <td key={field.name}>{row[field.name] || "-"}</td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <div className="p-4 border rounded-xl shadow-md">
                                                            <p>No Features Found</p>
                                                        </div>
                                                    )
                                                ) : null}
                                            </Tab>

                                            {/* Mithra Tab */}
                                            <Tab
                                                eventKey="mithra"
                                                title={
                                                    <div className="d-flex align-items-center">
                                                        <span>{tabTitles.mithra}</span>
                                                        {isTablemithtaOpen && (
                                                            <span style={{ marginLeft: "5px" }}>
                                                                ({mithradata.length})
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            >
                                                {isTablemithtaOpen ? (
                                                    mithradata.length > 0 ? (
                                                        <div className="table-responsive" style={{ maxHeight: "13rem", overflowY: "auto" }}>
                                                            <Table className="table table-bordered table-striped table-hover tableborderedth tablefontsize dashtbl">
                                                                <thead className="table-header" style={{ position: 'sticky', top: '-1px', zIndex: 2, backgroundColor: "#fff" }}>
                                                                    <tr>
                                                                        {mithrafields.map((field) => (
                                                                            <th key={field.name}>{field.alias}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {mithradata.map((row, index) => (
                                                                        <tr
                                                                            key={`${row.latitude}-${row.longitude}-${index}`}
                                                                            onClick={() => RowHandler(row.latitude, row.longitude)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {mithrafields.map((field) => (
                                                                                <td key={field.name}>{row[field.name] || "-"}</td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <div className="p-4 border rounded-xl shadow-md">
                                                            <p>No Features Found</p>
                                                        </div>
                                                    )
                                                ) : null}
                                            </Tab>

                                            {/* IPPB Tab */}
                                            <Tab
                                                eventKey="ippb"
                                                title={
                                                    <div className="d-flex align-items-center">
                                                        <span>{tabTitles.ippb}</span>
                                                        {isTableippbOpen && (
                                                            <span style={{ marginLeft: "5px" }}>
                                                                ({ippbdata.length})
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            >
                                                {isTableippbOpen ? (
                                                    ippbdata.length > 0 ? (
                                                        <div className="table-responsive" style={{ maxHeight: "13rem", overflowY: "auto" }}>
                                                            <Table className="table table-bordered table-striped table-hover tableborderedth tablefontsize dashtbl">
                                                                <thead className="table-header" style={{ position: 'sticky', top: '-1px', zIndex: 2, backgroundColor: "#fff" }}>
                                                                    <tr>
                                                                        {ippbfields.map((field) => (
                                                                            <th key={field.name}>{field.alias}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ippbdata.map((row, index) => (
                                                                        <tr
                                                                            key={`${row.latitude}-${row.longitude}-${index}`}
                                                                            onClick={() => RowHandler(row.latitude, row.longitude)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            {ippbfields.map((field) => (
                                                                                <td key={field.name}>{row[field.name] || "-"}</td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <div className="p-4 border rounded-xl shadow-md">
                                                            <p>No Features Found</p>
                                                        </div>
                                                    )
                                                ) : null}
                                            </Tab>
                                        </Tabs>
                                    </Card.Body>
                                )}
                            </Card>
                        </div>
                    </Draggable>
                )}
            </div>
        );
    }
};

export default Nearby;